<template>
  <div class="edit-profile">
    <div class="edit-header">
      <span class="brand-text-color">Edit Profile</span>
      <span @click="closeEdit">
        <i class="el-icon-close"></i>
      </span>
    </div>
    <el-form>
      <el-form-item label="Legal name">
        <template slot="label">
          <span class="brand-text-color">Legal name</span>
        </template>
        <el-input placeholder="Full name"></el-input>
      </el-form-item>

      <el-form-item label="Phone No">
        <template slot="label">
          <span class="brand-text-color">Phone No</span>
        </template>
        <el-input placeholder="Phone Number (numbers only no formating)"></el-input>
      </el-form-item>

      <el-form-item label="Email Address">
        <template slot="label">
          <span class="brand-text-color">Email Address</span>
        </template>
        <el-input placeholder="Email address"></el-input>
      </el-form-item>

      <el-form-item label="Address">
        <template slot="label">
          <span class="brand-text-color">Address</span>
        </template>
        <el-input placeholder="Address"></el-input>
      </el-form-item>

      <el-form-item>
        <button class="app-button">Save Changes</button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'UserInfo',
  props: ['closeEdit']

}
</script>

<style lang="scss" scoped>
.app-button {
  width: 100%;
  border-radius: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/EditProfile.vue